<template>
  <panel-section
    class="ai-visibility-trend-chart"
    :title="chart.title"
    :subtitle="chart.subtitle"
    :info-title="chart.infoTitle"
    card-class="ai-visibility-trend-chart__card"
  >
    <apex-chart
        type="area"
        height="273"
        :options="chartOptions"
        :series="series"
    />
  </panel-section>
</template>

<script>
import PanelSection from '../../../ui/cards/PanelSection.vue'

export default {
  name: 'VisibilityTrendChart',
  components: {
    PanelSection,
  },
  props: {
    chart: {
      type: Object,
      required: true,
    },
  },
  computed: {
    series() {
      return [
        {
          name: 'Visibility score',
          data: this.chart.points || [],
        },
      ]
    },
    chartOptions() {
      return {
        chart: {
          toolbar: {show: false},
          zoom: {enabled: false},
          sparkline: {enabled: false},
        },
        colors: ['var(--v-profileAnchorColor-base)'],
        dataLabels: {enabled: false},
        fill: {
          type: 'gradient',
          gradient: {
            gradientToColors: ['var(--v-cardBg-base)'],
            opacityFrom: 0.9,
            opacityTo: 0,
            stops: [0, 95, 100],
          },
        },
        grid: {
          borderColor: 'var(--v-gray13Color-base)',
          strokeDashArray: 4,
          padding: {
            bottom: 10
          }
        },
        markers: {
          size: 4,
          strokeWidth: 3,
          strokeColors: 'var(--v-cardBg-base)',
        },
        stroke: {
          curve: 'straight',
          width: 3,
        },
        tooltip: {
          enabled: true,
        },
        xaxis: {
          categories: this.chart.categories || [],
          labels: {
            offsetY: 10,
            style: {
              colors: 'var(--v-mainColor-base)',
              fontSize: '16px',
            },
          },
          axisBorder: {show: false},
          axisTicks: {show: false},
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 4,
          labels: {
            style: {
              colors: 'var(--v-mainColor-base)',
              fontSize: '16px',
            },
          },
        },
        annotations: {
          yaxis: [
            {
              y: 50,
              borderColor: '#2C2C2C',
              borderWidth: 2,
              strokeDashArray: 6,
              width: '100%',
              label: {
                text: this.chart.thresholdLabel,
                position: 'left',
                textAnchor: 'start',
                offsetY: -8,
                borderWidth: 0,
                style: {
                  background: 'transparent',
                  color: 'var(--v-mainColor-base)',
                  fontSize: '16px',
                  fontWeight: 400
                }
              }
            }
          ]
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ai-visibility-trend-chart {
  min-height: 390px;
}

.ai-visibility-trend-chart__card {
  min-height: 340px;
}
</style>
